import { onMounted, reactive } from 'vue'

const screens = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
}

const sm = val => val >= screens.sm // && val <= screens.md
const md = val => val >= screens.md // && val <= screens.lg
const lg = val => val >= screens.lg // && val <= screens.xl
const xl = val => val >= screens.xl

const getBreakpoint = w => {
  if (xl(w)) return 'xl'
  if (lg(w)) return 'lg'
  if (md(w)) return 'md'
  if (sm(w)) return 'sm'
  return 'all'
}
const debounce = function (func, wait) {
  var timeout
  return () => {
    const later = function () {
      timeout = null
    }
    const callNow = !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func()
  }
}

let breakpoints = reactive({
  w: 0,
  h: 0,
  is: 'sm',
  sm: true,
  md: false,
  lg: false,
  xl: false,
})

try {
  breakpoints = reactive({
    w: window.innerWidth,
    h: window.innerHeight,
    is: getBreakpoint(window.innerWidth),
    sm: sm(window.innerWidth),
    md: md(window.innerWidth),
    lg: lg(window.innerWidth),
    xl: xl(window.innerWidth),
  })

  window.addEventListener(
    'resize',
    debounce(() => {
      breakpoints.w = window.innerWidth
      breakpoints.h = window.innerHeight
      breakpoints.is = getBreakpoint(window.innerWidth)
      breakpoints.sm = sm(window.innerWidth)
      breakpoints.md = md(window.innerWidth)
      breakpoints.lg = lg(window.innerWidth)
      breakpoints.xl = xl(window.innerWidth)
    }, 200),
    false,
  )

  window.addEventListener(
    'load',
    debounce(() => {
      breakpoints.w = window.innerWidth
      breakpoints.h = window.innerHeight
      breakpoints.is = getBreakpoint(window.innerWidth)
      breakpoints.sm = sm(window.innerWidth)
      breakpoints.md = md(window.innerWidth)
      breakpoints.lg = lg(window.innerWidth)
      breakpoints.xl = xl(window.innerWidth)
    }, 200),
    false,
  )
} catch (error) {}

export default breakpoints
